import Slider from '../modules/slider';
import ToggleTab from '../modules/toggle-visibility-tab';

export default {
  init() {
    new Slider('.js-home-slider');
    const DescriptionTab = new ToggleTab('.js-description-show-more');
    DescriptionTab.init();
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHome.js